import {
	SET_SHOPS,
	SET_SHOP,
	CLEAR_SHOPS,
	CLEAR_SHOP,
	ADD_SHOP,
	UPDATE_SHOP,
	REMOVE_SHOP,
} from './actionTypes';

export const shop = (state = {}, action) => {
	switch (action.type) {
		case SET_SHOP:
			return action.payload;
		case UPDATE_SHOP:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_SHOP:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_SHOPS:
			return action.payload;
		case ADD_SHOP:
			return [...state, action.payload];
		case UPDATE_SHOP:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_SHOP:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_SHOPS:
			return [];
		default:
			return state;
	}
};
